import { CSSProperties, ReactElement } from 'react';
import { StyledDivider } from './styles';

interface DividerProps {
  position?: 'x' | 'y';
  style?: CSSProperties;
}

export function Divider({
  style,
  position = 'x',
}: Readonly<DividerProps>): ReactElement {
  return (
    <StyledDivider style={style} position={position} />
  );
}
